import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation updateMyProfile($id: String!, $data: updateUserInput!) {
    updateUser(id: $id, data: $data) {
      id
      status
      error {
        statusCode
        message
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const updateMyProfileRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;data: TYPES.UpdateUserInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'user/update_my_profile',
  async (
  params: {id: String;data: TYPES.UpdateUserInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.updateUser;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const updateMyProfileSlice = createSlice({
  name: 'update_my_profile',
  initialState: initialState,
  reducers: {
    updateMyProfileClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(updateMyProfileRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(updateMyProfileRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(updateMyProfileRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { updateMyProfileClear } = updateMyProfileSlice.actions;

export const updateMyProfile = createSelector(
  (state: RootState) => state.user.updateMyProfile.result,
  (state: RootState) => state.user.updateMyProfile.error,
  (state: RootState) => state.user.updateMyProfile.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default updateMyProfileSlice.reducer;